// MUI
// SVGs and Images
import Close from "@mui/icons-material/Close";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import { Dialog } from "@mui/material";

interface IImagePopup {
    element: any;
    avatarOpen: boolean;
    setAvatarOpen: () => void;
}

const ImagePopup = ({ element, avatarOpen, setAvatarOpen }: IImagePopup) => {
    async function downloadImage(imageSrc: any) {
        const image = await fetch(imageSrc);
        const imageBlob = await image.blob();
        const imageURL = URL.createObjectURL(imageBlob);
        const fileName = `avatar_beneficiaire_${element?.name}.png`;

        const link = document.createElement("a");
        link.href = imageURL;
        link.download = fileName;
        link.click();
    }

    return (
        <Dialog open={avatarOpen} onClose={() => setAvatarOpen()}>
            <Close
                onClick={() => setAvatarOpen()}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: "#EAEAEA",
                    cursor: "pointer",
                }}
            />
            <img src={element?.avatarUrl} style={{ width: "100%" }} />
            <DownloadForOfflineIcon
                sx={{
                    position: "absolute",
                    left: 8,
                    bottom: 8,
                    color: "#EAEAEA",
                    cursor: "pointer",
                }}
                onClick={() => downloadImage(element?.avatarUrl)}
            />
        </Dialog>
    );
};

export default ImagePopup;
